import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class AuthSessionService {
	private readonly localStorageKeys = ['user_info', 'user_all_info'];
	private readonly authCookieKey = 'authData';
	private readonly loggedOutMarkerKey = 'manual_logout';

	constructor(private readonly cookieService: CookieService) {}

	clear(): void {
		sessionStorage.setItem(this.loggedOutMarkerKey, '1');
		sessionStorage.removeItem('isMasterSession');
		this.deleteAuthCookie();

		for (const key of this.localStorageKeys) {
			localStorage.removeItem(key);
		}
	}

	clearLoggedOutMarker(): void {
		sessionStorage.removeItem(this.loggedOutMarkerKey);
	}

	isLoggedOutManually(): boolean {
		return sessionStorage.getItem(this.loggedOutMarkerKey) === '1';
	}

	private deleteAuthCookie(): void {
		const hostname = window.location.hostname;
		const domainVariants = [undefined, hostname, `.${hostname}`];

		for (const domain of domainVariants) {
			this.cookieService.delete(this.authCookieKey, '/', domain);
			this.cookieService.delete(this.authCookieKey, undefined, domain);
		}

		this.cookieService.deleteAll('/');
	}
}
